module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row webmaster-filter pad-top"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('MultiSelect', {
    ref: "multiselect",
    attrs: {
      "track-by": "webmaster_hash",
      "options": _vm.Storage.webmasters,
      "multiple": true,
      "close-on-select": false,
      "clear-on-select": false,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": _vm.$t('filter.webmaster'),
      "label": "webmaster_hash",
      "searchable": true,
      "disabled": _vm.disabled
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title"
        }, [_vm._v("\n              " + _vm._s(props.option.webmaster_hash) + " (" + _vm._s(props.option.web_login) + ")\n           ")])])]
      }
    }]),
    model: {
      value: (_vm.Storage.selectedWebmaster),
      callback: function($$v) {
        _vm.Storage.selectedWebmaster = $$v
      },
      expression: "Storage.selectedWebmaster"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08c7b699"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/filters/ByWebmasterFilter.vue
// module id = 508
// module chunks = 0